// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.forgotpasword_successBanner__uDDXq {
  width: 100%;
  max-width: 1100px;
  margin: 16px auto;
  background: #1f2937;
  color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(31, 41, 55, 0.08);
  padding: 14px 18px;
  position: relative;
  z-index: 20;
}

.forgotpasword_successInner__B4745 {
  display: flex;
  align-items: center;
  gap: 14px;
}

.forgotpasword_successIcon__3hVTt {
  width: 40px;
  height: 40px;
  object-fit: contain;
  flex: 0 0 40px;
}

.forgotpasword_successText__jEaI1 {
  flex: 1 1 auto;
}

.forgotpasword_successTitle__bjmWR {
  font-size: 18px;
  font-weight: 700;
  margin-bottom: 6px;
  color: #fff;
}

.forgotpasword_successMessage__oJmAu {
  font-size: 14px;
  color: rgba(255, 255, 255, 0.9);
  line-height: 1.4;
}

.forgotpasword_successClose__w9do\\+ {
  background: transparent;
  border: none;
  color: rgba(255, 255, 255, 0.9);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
  padding: 6px 8px;
  border-radius: 4px;
  flex: 0 0 auto;
}

.forgotpasword_errorBanner__lWIqv {
  width: 100%;
  max-width: 1100px;
  margin: 16px auto;
  background: #fff5f5;
  color: #7f1d1d;
  border-radius: 8px;
  box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);
  padding: 12px 16px;
  z-index: 20;
}

.forgotpasword_errorInner__UXgF4 {
  display: flex;
  align-items: center;
  gap: 12px;
}

.forgotpasword_errorIcon__1J3hK {
  width: 36px;
  height: 36px;
  object-fit: contain;
  flex: 0 0 36px;
}

.forgotpasword_errorTextBlock__Uhhep {
  flex: 1 1 auto;
}

.forgotpasword_errorTitle__kcjye {
  font-size: 16px;
  font-weight: 700;
  color: #7f1d1d;
  margin-bottom: 4px;
}

.forgotpasword_errorMessage__RIDZS {
  font-size: 13px;
  color: #9a1f1f;
}

/* =========================
   Utilities / small screens
   ========================= */
/* Make banners full width and centered */
.forgotpasword_successBanner__uDDXq,
.forgotpasword_errorBanner__lWIqv {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

/* Responsive: stack columns on small screens */
@media (max-width: 767px) {
  .forgotpasword_forgotLayout__EJbYl {
    flex-direction: column;
    gap: 18px;
    align-items: stretch;
  }
  .forgotpasword_formColumn__6W0vO {
    align-self: stretch;
    min-width: 0;
  }
  .forgotpasword_callCenterColumn__-4Gj7 {
    border-left: none;
    padding-left: 0;
    flex: 1 1 auto;
    justify-content: flex-start;
    /* top align when stacked */
  }
  .forgotpasword_callCenterCard__Op3Fz {
    width: 100%;
  }
  .forgotpasword_successInner__B4745,
  .forgotpasword_errorInner__UXgF4 {
    flex-direction: column;
    align-items: flex-start;
  }
  .forgotpasword_successClose__w9do\\+ {
    align-self: flex-end;
  }
}
/* forgotpasword.module.scss - equal width two column layout */
.forgotpasword_forgotLayout__EJbYl {
  display: flex;
  gap: 32px;
  margin: 20px;
  /* keep columns at exact halves and push them to fill the row */
  justify-content: space-between;
  align-items: center;
  box-sizing: border-box;
}

/* Left column: header + form (50%) */
.forgotpasword_formColumn__6W0vO {
  flex: 0 0 50%;
  max-width: 50%;
  min-width: 260px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  box-sizing: border-box;
  align-self: flex-start;
  /* keep left block top-aligned; remove to vertically center */
}

/* Right column: call center hours / contact info (50%) */
.forgotpasword_callCenterColumn__-4Gj7 {
  flex: 0 0 50%;
  max-width: 50%;
  min-width: 220px;
  box-sizing: border-box;
  /* visual separation */
  border-left: 1px solid #eee;
  padding-left: 28px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  /* vertically center the call center card relative to the left column */
  justify-content: center;
}

/* Card wrapper inside the right column */
.forgotpasword_callCenterCard__Op3Fz {
  background: #f7f7f7;
  border-radius: 8px;
  padding: 16px;
  box-shadow: 0 2px 8px rgba(15, 23, 32, 0.04);
  width: 100%;
  box-sizing: border-box;
}

/* Header inside left column spacing tweak */
.forgotpasword_formColumn__6W0vO .forgotpasword_login-head__NE26f {
  margin-bottom: 0;
}

/* Success / error banners remain unchanged */
.forgotpasword_successBanner__uDDXq,
.forgotpasword_errorBanner__lWIqv {
  max-width: 1100px;
  margin-left: auto;
  margin-right: auto;
}

/* Responsive: stack columns on small screens */
@media (max-width: 767px) {
  .forgotpasword_forgotLayout__EJbYl {
    flex-direction: column;
    gap: 18px;
    align-items: stretch;
    margin: 10px;
  }
  .forgotpasword_formColumn__6W0vO,
  .forgotpasword_callCenterColumn__-4Gj7 {
    flex: 1 1 auto;
    max-width: 100%;
    min-width: 0;
    padding-left: 0;
    border-left: none;
  }
  .forgotpasword_callCenterColumn__-4Gj7 {
    justify-content: flex-start;
  }
  .forgotpasword_callCenterCard__Op3Fz {
    width: 100%;
  }
}
.forgotpasword_form-control__oztoz {
  font-style: normal;
}
.forgotpasword_form-control__oztoz::placeholder {
  font-style: italic;
}`, "",{"version":3,"sources":["webpack://./src/styles/forgotpasword.module.scss"],"names":[],"mappings":"AAAA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,6CAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,eAAA;EACA,+BAAA;EACA,gBAAA;AACJ;;AAEA;EACI,uBAAA;EACA,YAAA;EACA,+BAAA;EACA,eAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,kBAAA;EACA,cAAA;AACJ;;AAEA;EACI,WAAA;EACA,iBAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EACA,kBAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;AACJ;;AAEA;EACI,aAAA;EACA,mBAAA;EACA,SAAA;AACJ;;AAEA;EACI,WAAA;EACA,YAAA;EACA,mBAAA;EACA,cAAA;AACJ;;AAEA;EACI,cAAA;AACJ;;AAEA;EACI,eAAA;EACA,gBAAA;EACA,cAAA;EACA,kBAAA;AACJ;;AAEA;EACI,eAAA;EACA,cAAA;AACJ;;AAEA;;8BAAA;AAGA,yCAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,kBAAA;AACJ;;AAEA,+CAAA;AACA;EACI;IACI,sBAAA;IACA,SAAA;IACA,oBAAA;EACN;EAEE;IACI,mBAAA;IACA,YAAA;EAAN;EAGE;IACI,iBAAA;IACA,eAAA;IACA,cAAA;IACA,2BAAA;IACA,2BAAA;EADN;EAIE;IACI,WAAA;EAFN;EAKE;;IAEI,sBAAA;IACA,uBAAA;EAHN;EAME;IACI,oBAAA;EAJN;AACF;AAOA,8DAAA;AAEA;EACI,aAAA;EACA,SAAA;EACA,YAAA;EAEA,+DAAA;EACA,8BAAA;EACA,mBAAA;EACA,sBAAA;AAPJ;;AAUA,qCAAA;AACA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,sBAAA;EACA,sBAAA;EACA,6DAAA;AAPJ;;AAUA,yDAAA;AACA;EACI,aAAA;EACA,cAAA;EACA,gBAAA;EACA,sBAAA;EAEA,sBAAA;EACA,2BAAA;EACA,kBAAA;EAEA,aAAA;EACA,sBAAA;EACA,SAAA;EAEA,uEAAA;EACA,uBAAA;AAVJ;;AAaA,yCAAA;AACA;EACI,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,4CAAA;EACA,WAAA;EACA,sBAAA;AAVJ;;AAaA,4CAAA;AACA;EACI,gBAAA;AAVJ;;AAaA,6CAAA;AACA;;EAEI,iBAAA;EACA,iBAAA;EACA,kBAAA;AAVJ;;AAaA,+CAAA;AACA;EACI;IACI,sBAAA;IACA,SAAA;IACA,oBAAA;IACA,YAAA;EAVN;EAaE;;IAEI,cAAA;IACA,eAAA;IACA,YAAA;IACA,eAAA;IACA,iBAAA;EAXN;EAcE;IACI,2BAAA;EAZN;EAeE;IACI,WAAA;EAbN;AACF;AAgBA;EACI,kBAAA;AAdJ;AAeI;EACI,kBAAA;AAbR","sourcesContent":[".successBanner {\n    width: 100%;\n    max-width: 1100px;\n    margin: 16px auto;\n    background: #1f2937;\n    color: #ffffff;\n    border-radius: 8px;\n    box-shadow: 0 6px 18px rgba(31, 41, 55, 0.08);\n    padding: 14px 18px;\n    position: relative;\n    z-index: 20;\n}\n\n.successInner {\n    display: flex;\n    align-items: center;\n    gap: 14px;\n}\n\n.successIcon {\n    width: 40px;\n    height: 40px;\n    object-fit: contain;\n    flex: 0 0 40px;\n}\n\n.successText {\n    flex: 1 1 auto;\n}\n\n.successTitle {\n    font-size: 18px;\n    font-weight: 700;\n    margin-bottom: 6px;\n    color: #fff;\n}\n\n.successMessage {\n    font-size: 14px;\n    color: rgba(255, 255, 255, 0.9);\n    line-height: 1.4;\n}\n\n.successClose {\n    background: transparent;\n    border: none;\n    color: rgba(255, 255, 255, 0.9);\n    font-size: 20px;\n    line-height: 1;\n    cursor: pointer;\n    padding: 6px 8px;\n    border-radius: 4px;\n    flex: 0 0 auto;\n}\n\n.errorBanner {\n    width: 100%;\n    max-width: 1100px;\n    margin: 16px auto;\n    background: #fff5f5;\n    color: #7f1d1d;\n    border-radius: 8px;\n    box-shadow: 0 6px 18px rgba(0, 0, 0, 0.04);\n    padding: 12px 16px;\n    z-index: 20;\n}\n\n.errorInner {\n    display: flex;\n    align-items: center;\n    gap: 12px;\n}\n\n.errorIcon {\n    width: 36px;\n    height: 36px;\n    object-fit: contain;\n    flex: 0 0 36px;\n}\n\n.errorTextBlock {\n    flex: 1 1 auto;\n}\n\n.errorTitle {\n    font-size: 16px;\n    font-weight: 700;\n    color: #7f1d1d;\n    margin-bottom: 4px;\n}\n\n.errorMessage {\n    font-size: 13px;\n    color: #9a1f1f;\n}\n\n/* =========================\n   Utilities / small screens\n   ========================= */\n/* Make banners full width and centered */\n.successBanner,\n.errorBanner {\n    max-width: 1100px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Responsive: stack columns on small screens */\n@media (max-width: 767px) {\n    .forgotLayout {\n        flex-direction: column;\n        gap: 18px;\n        align-items: stretch;\n    }\n\n    .formColumn {\n        align-self: stretch;\n        min-width: 0;\n    }\n\n    .callCenterColumn {\n        border-left: none;\n        padding-left: 0;\n        flex: 1 1 auto;\n        justify-content: flex-start;\n        /* top align when stacked */\n    }\n\n    .callCenterCard {\n        width: 100%;\n    }\n\n    .successInner,\n    .errorInner {\n        flex-direction: column;\n        align-items: flex-start;\n    }\n\n    .successClose {\n        align-self: flex-end;\n    }\n}\n\n/* forgotpasword.module.scss - equal width two column layout */\n\n.forgotLayout {\n    display: flex;\n    gap: 32px;\n    margin: 20px;\n\n    /* keep columns at exact halves and push them to fill the row */\n    justify-content: space-between;\n    align-items: center;\n    box-sizing: border-box;\n}\n\n/* Left column: header + form (50%) */\n.formColumn {\n    flex: 0 0 50%;\n    max-width: 50%;\n    min-width: 260px;\n    display: flex;\n    flex-direction: column;\n    gap: 18px;\n    box-sizing: border-box;\n    align-self: flex-start;\n    /* keep left block top-aligned; remove to vertically center */\n}\n\n/* Right column: call center hours / contact info (50%) */\n.callCenterColumn {\n    flex: 0 0 50%;\n    max-width: 50%;\n    min-width: 220px;\n    box-sizing: border-box;\n\n    /* visual separation */\n    border-left: 1px solid #eee;\n    padding-left: 28px;\n\n    display: flex;\n    flex-direction: column;\n    gap: 12px;\n\n    /* vertically center the call center card relative to the left column */\n    justify-content: center;\n}\n\n/* Card wrapper inside the right column */\n.callCenterCard {\n    background: #f7f7f7;\n    border-radius: 8px;\n    padding: 16px;\n    box-shadow: 0 2px 8px rgba(15, 23, 32, 0.04);\n    width: 100%;\n    box-sizing: border-box;\n}\n\n/* Header inside left column spacing tweak */\n.formColumn .login-head {\n    margin-bottom: 0;\n}\n\n/* Success / error banners remain unchanged */\n.successBanner,\n.errorBanner {\n    max-width: 1100px;\n    margin-left: auto;\n    margin-right: auto;\n}\n\n/* Responsive: stack columns on small screens */\n@media (max-width: 767px) {\n    .forgotLayout {\n        flex-direction: column;\n        gap: 18px;\n        align-items: stretch;\n        margin: 10px;\n    }\n\n    .formColumn,\n    .callCenterColumn {\n        flex: 1 1 auto;\n        max-width: 100%;\n        min-width: 0;\n        padding-left: 0;\n        border-left: none;\n    }\n\n    .callCenterColumn {\n        justify-content: flex-start;\n    }\n\n    .callCenterCard {\n        width: 100%;\n    }\n}\n\n.form-control{\n    font-style: normal;\n    &::placeholder{\n        font-style: italic;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"successBanner": `forgotpasword_successBanner__uDDXq`,
	"successInner": `forgotpasword_successInner__B4745`,
	"successIcon": `forgotpasword_successIcon__3hVTt`,
	"successText": `forgotpasword_successText__jEaI1`,
	"successTitle": `forgotpasword_successTitle__bjmWR`,
	"successMessage": `forgotpasword_successMessage__oJmAu`,
	"successClose": `forgotpasword_successClose__w9do+`,
	"errorBanner": `forgotpasword_errorBanner__lWIqv`,
	"errorInner": `forgotpasword_errorInner__UXgF4`,
	"errorIcon": `forgotpasword_errorIcon__1J3hK`,
	"errorTextBlock": `forgotpasword_errorTextBlock__Uhhep`,
	"errorTitle": `forgotpasword_errorTitle__kcjye`,
	"errorMessage": `forgotpasword_errorMessage__RIDZS`,
	"forgotLayout": `forgotpasword_forgotLayout__EJbYl`,
	"formColumn": `forgotpasword_formColumn__6W0vO`,
	"callCenterColumn": `forgotpasword_callCenterColumn__-4Gj7`,
	"callCenterCard": `forgotpasword_callCenterCard__Op3Fz`,
	"login-head": `forgotpasword_login-head__NE26f`,
	"form-control": `forgotpasword_form-control__oztoz`
};
export default ___CSS_LOADER_EXPORT___;
